angular.module('magpieValidation', [
  'ui.bootstrap',
  'magpieLineage',
  'magpieUtil'
]).
directive('magpieValidationSuite', function() {
  return {
    restrict: 'E',
    scope: {
      lineage: '=?',
      suite: '=?',
      validators: '=?',
      description: '@?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/validation/validation-suite.html',
    controller: function($scope) {
      if ($scope.description) {
        const description = JSON.parse($scope.description);

        $scope.lineage = description.lineage;
        $scope.suite = description.validationSuite;
        $scope.validators = description.validators;
        $scope.userPermissions = description.userPermissions;
      }
    }
  };
}).
directive('magpieValidationSuiteDetails', function() {
  return {
    restrict: 'E',
    scope: {
      suite: '=',
      validators: '='
    },
    templateUrl: 'components/magpie-display/validation/validation-suite-details.html'
  };
}).
directive('magpieValidatorList', function() {
  return {
    restrict: 'E',
    scope: {
      validators: '='
    },
    templateUrl: 'components/magpie-display/validation/validator-list.html'
  };
}).
directive('magpieValidator', function() {
  return {
    restrict: 'E',
    scope: {
      description: '=?',
      validator: '=?'
    },
    templateUrl: 'components/magpie-display/validation/validator.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.validator = $scope.description.validator;
      }
    }
  };
}).
directive('magpieValidatorDetails', function() {
  return {
    restrict: 'E',
    scope: {
      validator: '='
    },
    templateUrl: 'components/magpie-display/validation/validator-details.html',
    controller: function($scope) {
      $scope.isNumber = function(v) {
        return typeof v === 'number';
      };
    }
  };
}).
directive('magpieTableValidation', function() {
  return {
    restrict: 'E',
    scope: {
      validation: '@?',
      suiteRun: '=?',
      validators: '=?',
      validatorRuns: '=?'
    },
    templateUrl: 'components/magpie-display/validation/table-validation.html',
    controller: function($scope) {
      if ($scope.validation) {
        const validation = JSON.parse($scope.validation);

        $scope.validators = validation.validators || [];
        $scope.suiteRun = validation;
        $scope.validatorRuns = validation.validatorRuns || [];
      }
    }
  };
}).
directive('magpieSchemaValidation', function() {
  return {
    restrict: 'E',
    scope: {
      validation: '@?',
      validations: '=?'
    },
    templateUrl: 'components/magpie-display/validation/schema-validation.html',
    controller: function($scope) {
      if ($scope.validation) {
        $scope.validations = JSON.parse($scope.validation);
      }
    }
  };
}).
directive('magpieValidatedTables', function() {
  return {
    restrict: 'E',
    scope: {
      validations: '='
    },
    templateUrl: 'components/magpie-display/validation/validated-tables.html'
  };
}).
directive('magpieValidatedTableRecord', function() {
  return {
    restrict: 'AE',
    scope: {
      validation: '=',
      suiteRun: '=?',
      validators: '=?',
      validatorRuns: '=?'
    },
    templateUrl: 'components/magpie-display/validation/validated-table-record.html',
    controller: function($scope, $element, $timeout, $controller) {
      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
        $scope: $scope,
        $element: $element,
        $timeout: $timeout
      }));

      $scope.validators = $scope.validation.validators || [];
      $scope.suiteRun = $scope.validation;
      $scope.validatorRuns = $scope.validation.validatorRuns || [];
    }
  };
}).
directive('magpieValidationSuiteRun', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/validation/validation-suite-run.html'
  };
}).
directive('magpieValidationSuiteRunDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/validation/validation-suite-run-details.html'
  };
}).
directive('magpieValidatorRun', function() {
  return {
    restrict: 'AE',
    scope: {
      run: '='
    },
    templateUrl: 'components/magpie-display/validation/validator-run.html',
    controller: function($scope, $element, $timeout, $controller) {
      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
        $scope: $scope,
        $element: $element,
        $timeout: $timeout
      }));

      $scope.run.total = $scope.run.passedValidationRowCount + $scope.run.failedValidationRowCount
          + $scope.run.nullValidationRowCount;
      $scope.run.passRatio = 100 * $scope.run.passedValidationRowCount / $scope.run.total;
      $scope.run.failRatio = 100 * $scope.run.failedValidationRowCount / $scope.run.total;
      $scope.run.nullRatio = 100 * $scope.run.nullValidationRowCount / $scope.run.total;
    }
  };
}).
directive('magpieFieldSelector', function() {
  return {
    restrict: 'E',
    scope: {
      fieldSelector: '='
    },
    templateUrl: 'components/magpie-display/validation/field-selector.html'
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/validation/magpie-validation.js